
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/pengelolaan-kinerja/perencanaan/sepakati",
      function () {
        return require("private-next-pages/pengelolaan-kinerja/perencanaan/sepakati/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/pengelolaan-kinerja/perencanaan/sepakati"])
      });
    }
  